<template>
  <div class="toolbar-layout">
    <img class="toolbar-layout__icon" src="@/assets/img/png/nav-logo.png" />
    <b-button
      type="is-light"
      icon-left="close"
      @click="$emit('on-click')"
    ></b-button>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
  name: 'MenuToolbar'
})
</script>

<style lang="sass" scoped>
@import @/assets/sass/style

.toolbar-layout
    height: 50px
    display: flex
    flex-direction: row
    justify-content: space-between
    background: $white
    align-items: center
    padding: 0 10px

    &__icon
      width: 80px
      height: 30px
</style>
